<template>
  <transition name="fade" mode="out-in">
    <section class="pay-result">
      <top-header
        class="page-top-header"
        :showLangSelector="false"
      ></top-header>
      <div class="result-info-container">
        <PayState
          v-if="result == SUCCESS"
          class="result-type-wrapper"
          :tips="newStoreSuccessTips"
          :title="letter.storeSuccess"
          state="success"
        >
          <!-- 双倍券结果提示语 -->
          <template v-if="hasDoubleSend">
            <p class="opera-tips">{{ letter.doubleSendInfo }}</p>
          </template>
        </PayState>
        <PayState
          v-if="result == WAITING"
          class="result-type-wrapper"
          :tips="letter.storeSuccessTips"
          :title="letter.storeAcceptance"
          state="storing"
        ></PayState>
        <PayState
          v-if="result == FAIL"
          class="result-type-wrapper"
          :tips="letter.storeFailTips"
          :title="letter.storeFail"
          state="fail"
        ></PayState>
        <div class="order-info-wrapper">
          <div class="order-info-container">
            <div class="game-info">
              <span class="floatL">{{ letter.creatework_game }}</span>
              <span class="floatR bold">{{ gameName }}</span>
            </div>
            <div class="order-info">
              <div class="order-info-list">
                <span class="floatL">UID：</span>
                <span class="floatR bold">{{ userId || uid }}</span>
              </div>
              <div class="order-info-list">
                <span class="floatL">{{ letter.orderNumber }}：</span>
                <span class="floatR bold">{{ orderId }}</span>
              </div>
              <div class="order-info-list">
                <span class="floatL">{{ letter.buyProduct }}：</span>
                <span class="floatR bold">{{ payResult }}</span>
              </div>
            </div>
            <ul class="payment-info">
              <li class="payment-info-list">
                <span class="floatL">{{ letter.couponOrderTotal }}：</span>
                <span class="floatR bold ltr-dire" v-if="hasUseCoupon">
                  {{ amountDesc }}
                  <span v-if="isShowTax && !hasUseCoupon">
                    {{ `+ ${curTax} ${currency}(tax)` }}
                  </span>
                </span>
                <span class="floatR bold ltr-dire" v-else>
                  <template v-if="isJpPlatform">
                    {{ priceAmount }}
                  </template>
                  <template v-else>
                    {{ `${amount}${currency}` }}
                    <span v-if="isShowTax">
                      {{ `+ ${curTax} ${currency}(tax)` }}
                    </span>
                  </template>
                </span>
              </li>
              <li class="payment-info-list" v-if="hasUseCoupon">
                <span class="floatL">{{ letter.couponCoupon }}：</span>
                <Mark class="floatR bold bigMark ltr-dire">
                  {{ couponInfoName }}
                </Mark>
              </li>
              <li class="payment-info-list" v-if="hasUseCoupon">
                <span class="floatL">{{ letter.transactionAmount }}：</span>
                <Mark class="floatR bold bigMark ltr-dire highlight">
                  {{ discountAfterAmount }}
                  <span v-if="isShowTax">
                    {{ `+ ${curTax} ${currency}(tax)` }}
                  </span>
                </Mark>
              </li>
              <li class="payment-info-list" v-if="result == FAIL">
                <span class="floatL">{{ letter.failReason }}：</span>
                <span class="floatR bold middleMark pay-errmsg">
                  {{ msg }}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <p class="opera-tips mb0">{{ letter.screenshotTips }}</p>
        <template v-if="result == SUCCESS && showQuickPayTip">
          <p class="opera-tips mb0">{{ letter.quickcard_result_tip_one }}</p>
          <p class="opera-tips mb0">{{ letter.quickcard_result_tip_two }}</p>
          <p
            class="opera-tips look-more mb0"
            @click="isShowQuickPayPopup = true"
          >
            {{ letter.quickcard_learn_more }}
          </p>
        </template>
      </div>
      <div class="follow-operation center" v-if="result == SUCCESS">
        <!-- 再储值一笔 -->
        <Button
          class="follow-operation-btn restore"
          pointClass="j-restore-btn"
          @click="reStore"
        >
          {{ letter.payOntherORder }}
        </Button>
      </div>
      <div class="follow-operation center" v-if="result == WAITING">
        <!-- 再储值一笔 -->
        <Button
          class="follow-operation-btn restore"
          pointClass="j-restore-btn"
          @click="reStore"
          :loading="loading"
        >
          {{ letter.payOntherORder }}
        </Button>
      </div>
      <div class="follow-operation" v-if="result == FAIL">
        <Button
          class="follow-operation-btn contact-us"
          @click="showFeebackPage"
          pointClass="j-go-feeback-btn"
          v-if="!uidGame && needServiceBtn"
        >
          {{ letter.contactService }}
        </Button>
        <Button
          class="follow-operation-btn"
          pointClass="j-restore-btn"
          @click="reStore"
        >
          {{ letter.reStore }}
        </Button>
      </div>
      <form v-bind:action="postAction" method="post">
        <input
          type="hidden"
          name="cardType"
          v-bind:value="post_fields.cardType"
        />
        <input
          type="hidden"
          name="gatewayNo"
          v-bind:value="post_fields.gatewayNo"
        />
        <input
          type="hidden"
          name="goodsInfo"
          v-bind:value="post_fields.goodsInfo"
        />
        <input type="hidden" name="merNo" v-bind:value="post_fields.merNo" />
        <input
          type="hidden"
          name="notifyUrl"
          v-bind:value="post_fields.notifyUrl"
        />
        <input
          type="hidden"
          name="orderAmount"
          v-bind:value="post_fields.orderAmount"
        />
        <input
          type="hidden"
          name="orderCurrency"
          v-bind:value="post_fields.orderCurrency"
        />
        <input
          type="hidden"
          name="orderNo"
          v-bind:value="post_fields.orderNo"
        />
        <input type="hidden" name="remark" v-bind:value="post_fields.remark" />
        <input
          type="hidden"
          name="returnUrl"
          v-bind:value="post_fields.returnUrl"
        />
        <input
          type="hidden"
          name="shopperId"
          v-bind:value="post_fields.shopperId"
        />
        <input
          type="hidden"
          name="signInfo"
          v-bind:value="post_fields.signInfo"
        />
        <input type="hidden" name="token" v-bind:value="post_fields.token" />
        <input
          type="hidden"
          name="verifyBillingAddress"
          v-bind:value="post_fields.verifyBillingAddress"
        />
        <button type="submit" id="postOrderToBank" class="hide"></button>
      </form>
      <ServiceIconBtn
        v-if="result != FAIL && needServiceBtn"
        :serverId="sid"
        :roleId="roleId"
        :roleName="roleName"
        :gameId="gameId"
        :isUidLogin="isUidLogin"
        :uid="uid"
        :loginAccount="loginAccount"
      ></ServiceIconBtn>
      <QuickPayCardPopup
        @close="isShowQuickPayPopup = false"
        v-if="isShowQuickPayPopup"
        :languages="letter"
      ></QuickPayCardPopup>
    </section>
  </transition>
</template>
<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import { b64DecodeUnicode, changePriceFormat } from '@utiles/officialStore';
import bridge from '@utiles/officialStore/bridge';
import { getWebviewPageFlag } from '@store/officialWebStore/storager';
import { UPDATE_GAMEID } from '@store/officialWebStore';
import { mapState, mapGetters } from 'vuex';
import PayState from '@components/officialWebStore//paytype/PayState.vue';
import ServiceIconBtn from '@components/officialWebStore/ServiceIcon.vue';
import TopHeader from '@components/officialWebStore/TopHeader.vue';
import QuickPayCardPopup from '@components/officialWebStore/paytype/QuickPayCardPopup.vue';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
import contactService from '@mixins/officialWebStore/contactService';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();
let gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';
export default {
  name: 'resultPage',
  mixins: [contactService],
  data() {
    let store_url_params = decodeURIComponent(
      globalConfig.getHrefParam('store_url_params').replace('#/result', '')
    );
    let storeParams = b64DecodeUnicode(store_url_params);
    let postOrderParams = {};
    const webviewEnv = getWebviewPageFlag() == 1;
    try {
      const parsed = JSON.parse(storeParams);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        postOrderParams = parsed;
      }
    } catch (e) {
      console.error(e);
    }

    return {
      uidGame: globalConfig.isUidGame(),
      needServiceBtn: postOrderParams['hideService'] != 1,
      result: globalConfig.getHrefParam('result'),
      msg: globalConfig.getHrefParam('msg'),
      gameId: gameId,
      sid: globalConfig.getHrefParam('server_sid'),
      serverId: globalConfig.getHrefParam('server_id'),
      orderId: globalConfig.getHrefParam('order_id'),
      coin: globalConfig.getHrefParam('coin'),
      sub_coin: globalConfig.getHrefParam('sub_coin'),
      extra_coin: globalConfig.getHrefParam('extra_coin'),
      coinName: globalConfig.getHrefParam('coin_name'),
      mode: postOrderParams['mode'],
      userId: postOrderParams['userId'] ? postOrderParams['userId'] : '',
      SUCCESS: 1,
      FAIL: 0,
      WAITING: 2,
      postOrderParams,
      webviewEnv,
      postAction: '',
      post_fields: {},
      isWeb: '1', //写死为web,之前是从链接获取
      pageSource: postOrderParams['pageSource'],
      roleId: postOrderParams['roleId'],
      roleName: postOrderParams['roleName'],
      packageName: postOrderParams['packageName'],
      productRemark: postOrderParams['productRemark'],
      hasDoubleSend: postOrderParams['productRemark']?.includes?.(
        'SpecialParamWithDoubleSend'
      ),
      loading: false,
      showQuickPayTip:
        postOrderParams['f_pay_type'] === 'world_pay' ||
        (postOrderParams['f_pay_type'] === 'alipay' &&
          postOrderParams['pay_type'] &&
          postOrderParams['pay_type'].toLowerCase().indexOf('card') === 0),
      isShowQuickPayPopup: false,
      isUidLogin: postOrderParams['isUidLogin'] == '1',
      uid: postOrderParams['uid'] ? postOrderParams['uid'] : '',
      loginAccount: postOrderParams['loginAccount'],
      isShowOrderRecord: false,
      currency: postOrderParams['currency'],
      hasUseCoupon: postOrderParams['couponId'],
      couponInfoName: postOrderParams['couponInfoName'],
      discountAfterAmount: postOrderParams['discountAfterAmount'],
      cid: postOrderParams['cid'] ? postOrderParams['cid'] : '',
      scid: postOrderParams['scid'] ? postOrderParams['scid'] : '',
      productType: postOrderParams['productType']
        ? postOrderParams['productType']
        : '',
      productId: postOrderParams['productId']
        ? postOrderParams['productId']
        : '',
      cpProductId: postOrderParams['cpProductId']
        ? postOrderParams['cpProductId']
        : '',
      amount: postOrderParams['amount'] ? postOrderParams['amount'] : '',
      fPayType: postOrderParams['f_pay_type']
        ? postOrderParams['f_pay_type']
        : '',
      paytype: postOrderParams['paytype'] ? postOrderParams['paytype'] : '',
      priceSubCoinName: postOrderParams['priceSubCoinName']
        ? postOrderParams['priceSubCoinName']
        : '', // 渠道拆单道具名称
      priceExtraCoinName: postOrderParams['priceExtraCoinName']
        ? postOrderParams['priceExtraCoinName']
        : '', // 渠道加码道具名称
      productExtraCoin: postOrderParams['productExtraCoin']
        ? postOrderParams['productExtraCoin']
        : '', // 开发商加码PRODUCT_EXTRA_COIN
      productExtraCoinName: postOrderParams['productExtraCoinName']
        ? postOrderParams['productExtraCoinName']
        : '', // 开发商加码道具名称
      curTax: postOrderParams['curTax'] || 0,
      location: postOrderParams['location'] || '',
      flowId: postOrderParams['flowId'] ? postOrderParams['flowId'] : ''
    };
  },
  beforeCreate() {
    this.$store.commit(UPDATE_GAMEID, gameId);
  },
  created() {
    this.sendResultBiData();
  },
  computed: {
    ...mapState({
      isCoinsSubmitType: state => state.isCoinsSubmitType,
      lang: state => state.lang
    }),
    ...mapGetters(['isJpPlatform', 'gameInfoConfig']),
    gameName() {
      return globalConfig.getHrefParam('game_name');
    },
    payResult() {
      let illegalPay = globalConfig.getHrefParam('illegal_pay') * 1;
      let transAmount = globalConfig.getHrefParam('trans_amount');
      let desc = this.postOrderParams && this.postOrderParams.productDesc;
      // 非点卡默认显示
      if (!transAmount) {
        return desc;
      }

      // sub_coin不为0说明为拆单情况
      if (+this.sub_coin && this.coinName && transAmount * 1 > 0) {
        let desArray = [this.sub_coin + ' ' + this.priceSubCoinName];
        if (this.extra_coin && this.extra_coin * 1 > 0) {
          desArray.push(this.extra_coin + ' ' + this.priceExtraCoinName);
        }
        /**
         *  illegalPay为1指点卡小买大，显示【渠道拆单内容+渠道加码内容】
         *  不为1说明大买小，显示【商品名 + 开发商加码PRODUCT_EXTRA_COIN + 渠道拆单内容 + 渠道加码内容 】
         */
        if (illegalPay === 1) {
          return desArray.join(` ${this.letter.and || 'and'} `);
        } else {
          // 有开发商加码，则拼接上
          if (+this.productExtraCoin) {
            // 2024.5.29 运营需求: 庄恺杰 特殊处理371ROV首充赠送水晶名称
            if (+this.gameId === 371) {
              desArray.unshift(this.productExtraCoin + ' Crystals');
            } else {
              desArray.unshift(
                this.productExtraCoin + ' ' + this.productExtraCoinName
              );
            }
          }
          return desc.replace(
            /\s((\d*)|(\d*\.\d*))\s.*$/,
            ' ' + desArray.join(` ${this.letter.and || 'and'} `)
          );
        }
      }
      return desc;
    },
    letter() {
      return this.$store.state.letter;
    },
    priceAmount() {
      let currency = globalConfig.getHrefParam('currency');
      let transAmount = globalConfig.getHrefParam('trans_amount');
      if (currency && transAmount) {
        return changePriceFormat(currency, transAmount) + ' ' + currency;
      } else {
        // 日本平台固定写死单位：JPY
        let postCurrency = this.isJpPlatform
          ? 'JPY'
          : this.postOrderParams && this.postOrderParams.currency;
        let amountDesc =
          this.postOrderParams && this.postOrderParams.amountDesc;
        return changePriceFormat(postCurrency, amountDesc) + ' ' + postCurrency;
      }
    },
    amountDesc() {
      // 日本平台固定写死单位：JPY
      let postCurrency = this.isJpPlatform
        ? 'JPY'
        : this.postOrderParams && this.postOrderParams.currency;
      let amountDesc = this.postOrderParams && this.postOrderParams.amountDesc;
      return changePriceFormat(postCurrency, amountDesc) + ' ' + postCurrency;
    },
    newStoreSuccessTips() {
      //2024/01/25 寻道大千新增儲值成功引导文案
      const xddqWebsiteList = [335, 337, 339, 340];
      if (xddqWebsiteList.includes(+this.gameId)) {
        return `${this.letter.storeSuccessTips} <br />
        ${
          this.gameInfoConfig.storeSuccessEmailTips[this.lang] ||
          this.gameInfoConfig.storeSuccessEmailTips['en-US'] ||
          ''
        }`;
      } else {
        return this.letter.storeSuccessTips;
      }
    },
    isShowTax() {
      return +this.curTax > 0 && this.location === 'US';
    }
  },
  methods: {
    sendResultBiData() {
      window.webstorev2DataLayer.push({
        eventName: 'payment_result',
        uid: this.uid,
        loginAccount: this.loginAccount || '',
        roleId: this.roleId || '',
        roleName: this.roleName || '',
        serverId: this.serverId,
        cid: this.cid,
        scid: this.scid,
        eventValue: {
          result: this.result,
          product_type: this.productType || '',
          cp_product_id: this.cpProductId,
          product_id: this.productId,
          product_num: '1',
          product_currency: this.currency,
          product_money: this.amount,
          local_currency: this.currency,
          local_money: this.amount,
          f_pay_type: this.fPayType,
          pay_type: this.paytype,
          order_id: this.orderId,
          ...this.postOrderParams?.biCouponInfo,
          uid: this.uid,
          loginAccount: this.loginAccount || '',
          roleId: this.roleId || '',
          roleName: this.roleName || '',
          serverId: this.serverId,
          cid: this.cid,
          scid: this.scid
        }
      });
    },
    backGame() {
      bridge.callSdkMethod('closeWebview');
    },
    showFeebackPage() {
      clickButton({
        btnName: 'contact_service',
        locationKey: locationType.resultPage
      });
      if (this.isJpPlatform) {
        this.jpService({
          gameId: this.gameId,
          pcServerId: this.sid,
          roleId: this.roleId,
          roleName: this.roleName,
          uid: this.uid
        });
        return;
      }
      this.openGlobalService({
        gameId: this.gameId,
        roleId: this.roleId,
        roleName: this.roleName,
        serverId: this.sid,
        isUidLogin: this.isUidLogin,
        uid: this.uid,
        loginAccount: this.loginAccount
      });
    },
    getPayPagePath(params = {}) {
      if (process.env.NODE_ENV !== 'production') {
        return getGlobalGetGotoLink({
          link: `https://gabres.${mainHost}/officialWebStore.html?${new URLSearchParams(
            params
          ).toString()}`
        });
      }
      return getGlobalGetGotoLink({
        link: `https://pay.${mainHost}/platform/officialWebStore.html?${new URLSearchParams(
          params
        ).toString()}`
      });
    },
    reStore() {
      clickButton({
        btnName: 're_store',
        locationKey: locationType.resultPage
      });
      this.loading = true;
      if (this.isJpPlatform) {
        window.location.href =
          process.env.NODE_ENV !== 'production'
            ? getGlobalGetGotoLink({
                link: `https://gabres.${mainHost}/officialWebStore.html?gameId=${this.gameId}&cid=${this.cid}&scid=${this.scid}&roleId=${this.roleId}&serverId=${this.sid}&mode=${this.mode}`
              })
            : getGlobalGetGotoLink({
                link: `https://jpstore.${window.atob(
                  'MzdnYW1lcy5jb20='
                )}/mobile/signin?gameId=${this.gameId}&cid=${this.cid}&scid=${
                  this.scid
                }&roleId=${this.roleId}&serverId=${this.sid}&mode=${this.mode}`
              });
      } else {
        window.location.href = this.getPayPagePath({
          gameId: this.gameId,
          cid: this.cid,
          scid: this.scid,
          roleId: this.roleId,
          serverId: this.sid,
          mode: this.mode,
          flowId: this.flowId
        });
      }
    }
  },
  components: {
    PayState,
    ServiceIconBtn,
    QuickPayCardPopup,
    TopHeader
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.pay-result {
  position: relative;
  background: #f6f6f6;
  min-height: 100%;
}
.page-top-header {
  position: relative;
}
.result-info-container {
  position: relative;
  padding: 0 20px;
}
.order-info-wrapper {
  display: inline-block;
  margin: 45px auto;
  width: 100%;
  .order-info-container {
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0 20px;
    background: #fff;
    font-size: 22px;
    color: #333;
    border: 1px solid #dddddd;
    border-radius: 10px;
  }
  .game-info {
    display: inline-block;
    border-bottom: 1px solid #444444;
    width: 100%;
    min-height: 80px;
    line-height: 80px;
  }
  .order-info {
    display: inline-block;
    padding-top: 22px;
    padding-bottom: 16px;
    border-bottom: 1px solid #444444;
    width: 100%;
  }
  .payment-info {
    border-bottom-width: 0;

    @extend .order-info;
  }
  .order-info-list,
  .payment-info-list {
    display: inline-block;
    width: 100%;
    line-height: 52px;
  }
}
.follow-operation {
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 30px;
  width: 613px;
  margin: 45px auto;
  &.center {
    justify-content: center;
  }
  .follow-operation-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 266px;
    height: 80px;
    font-size: 26px;
    color: #fff;
    border-radius: 40px;
    cursor: pointer;
    padding: 0 30px;
    background: $btnBg;
    &.contact-us {
      background: $popupSubBtn;
      cursor: pointer;
    }
  }
}
.look-detail {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  color: #b07d1a;
}
.opera-tips {
  margin: 0 auto;
  margin-bottom: 80px - 54px;
  width: 679px;
  line-height: 30px;
  text-align: left;
  font-size: 22px;
  color: #666;
  &.look-more {
    cursor: pointer;
    color: #b07d1a;
  }
  &.mb0 {
    margin-bottom: 0;
  }
}
.middleMark {
  color: #9e1e1e;
}
.bigMark {
  font-size: 36px;
}
.bold {
  font-weight: bold;
}
.pay-errmsg {
  display: inline-block;
  max-width: 100%;
  word-break: break-word;
}
@media screen and (orientation: landscape) {
  .result-info-container {
    width: 750px;
    margin: 0 auto;
  }
  .follow-operation {
    position: relative !important;
    left: unset !important;
    transform: unset !important;
    bottom: unset !important;
    margin: 20px auto !important;
  }
  .bigMark {
    font-size: 28px;
  }
}
</style>
